import useEditCustomer from './hooks/useEditCustomer'
import EditCustomerView from './components/EditCustomerView'

const EditCustomerMain = () => {
  const vm = useEditCustomer()
  return <EditCustomerView {...vm} />
}

export default EditCustomerMain
